import { render, staticRenderFns } from "./DniPhotoCaptureModal.vue?vue&type=template&id=2265a4a4&scoped=true"
import script from "./DniPhotoCaptureModal.vue?vue&type=script&lang=js"
export * from "./DniPhotoCaptureModal.vue?vue&type=script&lang=js"
import style0 from "./DniPhotoCaptureModal.vue?vue&type=style&index=0&id=2265a4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265a4a4",
  null
  
)

export default component.exports